export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_xRiL9n58n',
      userPoolClientId: '3um3c8va5sv5bp8skln2q41ht',
      region: 'us-east-1',
      loginWith: {
        oauth: {
          domain: 'auth.mcfa.cloud',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: ['https://manage.mcfa.cloud'],
          redirectSignOut: ['https://manage.mcfa.cloud'],
          responseType: 'code' as const,
        },
        email: true,
        username: true,
      },
    },
  },
  WebSocket: {
    url: process.env.REACT_APP_WEBSOCKET_URL || 'wss://yhfa5kgsyg.execute-api.us-east-1.amazonaws.com/prod',
  },
};